import { gql } from "@apollo/client";
import { permitDetailFragment, PermitDetailRaw } from "../fragments";
import { PermitDocumentReviewStatus } from "common/types";

export const REVIEW_PERMIT_APPLICATION = gql`
  mutation ReviewPermitApplication(
    $action: permit_application_review_action!
    $permitId: uuid!
    $documentProposalId: uuid!
    $comment: String
    $documentReviews: [permit_document_review_input!]
  ) {
    reviewedApplication: review_permit_application(
      action: $action
      permit_id: $permitId
      document_proposal_id: $documentProposalId
      comment: $comment
      document_reviews: $documentReviews
    ) {
      permit {
        ...permitDetailFragment
      }
    }
  }
  ${permitDetailFragment}
`;

export type ReviewPermitApplicationAction = "approve" | "deny" | "request_information";

export interface ReviewPermitApplicationVars {
  action: ReviewPermitApplicationAction;
  permitId: string;
  documentProposalId: string;
  comment?: string;
  documentReviews?: PermitDocumentReviewInput[];
}

export interface PermitDocumentReviewInput {
  id: string;
  review_status: PermitDocumentReviewStatus;
}

export interface ReviewPermitApplicationData {
  reviewedApplication: {
    permit: PermitDetailRaw;
  };
}
